// frontend/src/navigation/visionNavigation.js
// Project:      Vision ANPR by Castle Traffic Ltd - Automatic Number Plate Recognition
// Author:       Leon du Plooy - Castle Traffic Ltd - Copyright 2025
// Contact:      dev@castle-traffic.co.uk
// Created:      2026-09-04
// Updated:      2026-10-07 15:18 BST
//
// Purpose:
//               Canonical navigation definition shared by desktop and mobile
//               Vision Systems application-shell navigation presentations.
//
// Design Rule:
//               Navigation labels, paths, ordering, and icons are defined here
//               once so desktop Sidebar and future mobile drawer cannot drift.

import React from "react";

import {
  FaTh,
  FaChartBar,
  FaUsers,
  FaCogs,
  FaCubes,
  FaFileAlt,
  FaBuilding,
  FaUser,
  FaCalendarAlt,
  FaComments,
  FaChartLine,
  FaPoundSign,
  FaTachometerAlt,
  FaCodeBranch,
  FaVideo,
  FaTasks,
} from "react-icons/fa";

const visionNavigation = [
  {
    icon: <FaTh />,
    label: "Dashboards",
    path: "/dashboard",
  },
  {
    icon: <FaCubes />,
    label: "Jobs",
    path: "/dashboard/jobs",
  },
  {
    icon: <FaTasks />,
    label: "Tasks",
    path: "/dashboard/tasks",
  },
  {
    icon: <FaCalendarAlt />,
    label: "Calendar",
    path: "/dashboard/calendar",
  },
  {
    icon: <FaTachometerAlt />,
    label: "Monitor",
    path: "/dashboard/monitor",
  },
  {
    icon: <FaVideo />,
    label: "Cameras",
    path: "/dashboard/cameras",
  },
  {
    icon: <FaCodeBranch />,
    label: "Workflows",
    path: "/dashboard/workflows",
  },
  {
    icon: <FaChartLine />,
    label: "Opportunities",
    path: "/dashboard/opportunities",
  },
  {
    icon: <FaPoundSign />,
    label: "Quotes",
    path: "/dashboard/quotes",
  },
  {
    icon: <FaFileAlt />,
    label: "Reporting",
    path: "/dashboard/reporting",
  },
  {
    icon: <FaComments />,
    label: "Messaging",
    path: "/dashboard/messaging",
  },
  {
    icon: <FaBuilding />,
    label: "Customers",
    path: "/dashboard/clients",
  },
  {
    icon: <FaUser />,
    label: "Contacts",
    path: "/dashboard/contacts",
  },
  {
    icon: <FaUsers />,
    label: "User Management",
    path: "/dashboard/users",
  },
  {
    icon: <FaCogs />,
    label: "System",
    path: "/dashboard/system",
  },
  {
    icon: <FaChartBar />,
    label: "Widgets",
    path: "/dashboard/widgets",
  },
];

export default visionNavigation;
